import React from 'react';
import PropTypes from 'prop-types';

import * as ActPropTypes from 'types/act';

import EligibleFriends from './EligibleFriends';
import IneligibleContacts from '../IneligibleContacts';

export default function SelectContactComponent(props) {
  const {
    eligibleFriends,
    ineligibleContacts,
    onChange,
    value,
  } = props;
  return (
    <div className="act__contact-choice-method act__contact-choice-method--select-contact">
      <label
        className="act__contact-choice-label"
        htmlFor="js-targetCharacterId"
      >
        Select a contact:
        <select
          id="js-targetCharacterId"
          name="targetCharacterId"
          className="form__control form__control--no-border act__form-input"
          onChange={onChange}
          value={value}
        >
          <EligibleFriends eligibleFriends={eligibleFriends} />
        </select>
      </label>
      <IneligibleContacts
        ineligibleContacts={ineligibleContacts}
      />
    </div>
  );
}

SelectContactComponent.propTypes = {
  eligibleFriends: PropTypes.arrayOf(ActPropTypes.eligibleFriend).isRequired,
  ineligibleContacts: PropTypes.arrayOf(ActPropTypes.ineligibleContact).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};

SelectContactComponent.defaultProps = {
  value: undefined,
};